import { Button, Plus } from "@gearbox-protocol/deploy-tools-ui";
import { Reorder } from "framer-motion";
import { customAlphabet } from "nanoid/non-secure";
import type { FC } from "react";
import { useCallback } from "react";
import type { Control } from "react-hook-form";
import { useFieldArray } from "react-hook-form";

const nanoid = customAlphabet("0123456789abcdefghijklmnopqrstuvwxyz", 4);

import type { ForkSchema } from "../schema";
import { DEFAULT_DOCKER_IMAGE } from "./defaults";
import ScriptControl from "./ScriptControl";

interface ForkScriptsProps {
  control: Control<ForkSchema>;
}

export const ForkScripts: FC<ForkScriptsProps> = ({ control }) => {
  const scripts = useFieldArray({ control, name: "scripts", keyName: "uuid" });
  const {
    append: appendScript,
    replace: replaceScripts,
    remove: removeScript,
  } = scripts;

  const addScript = useCallback(() => {
    appendScript({
      id: `script-${nanoid(8)}`,
      docker: DEFAULT_DOCKER_IMAGE,
      args: undefined,
    });
  }, [appendScript]);

  return (
    <div className="flex flex-col gap-y-2 px-4 py-2 border rounded-md">
      <div className="flex flex-row gap-2 items-center">
        <h3>Scripts</h3>
        <Button variant="ghost" size="icon" onClick={addScript} type="button">
          <Plus />
        </Button>
      </div>

      <Reorder.Group
        values={scripts.fields}
        onReorder={replaceScripts}
        axis="y"
      >
        {scripts.fields.map((f, i) => (
          <ScriptControl
            key={f.id}
            control={control}
            field={f}
            name="scripts"
            index={i}
            removeScript={removeScript}
          />
        ))}
      </Reorder.Group>
    </div>
  );
};
